"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const react_auth_code_input_1 = __importDefault(require("react-auth-code-input"));
const material_1 = require("@mui/material");
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const ConventionModalWrapper = styled_components_1.default.div `
  padding: 15% 5%;
  text-align: center;

  .modal-title {
    font-size: 22px;
    letter-spacing: 0.5px;
    margin-bottom: 20px;
    text-align: center;

    @media (min-width: 1024px) {
      font-size: 30px;
      margin-bottom: 40px;
    }
  }

  div:first-of-type {
    text-align: center;
  }

  .code-input {
    width: 40px;
    height: 40px;
    padding: 0;
    font-size: 24px;
    text-align: center;
    margin-right: 12px;
    text-transform: uppercase;
    color: #494949;
    border: 1px solid #d6d6d6;
    border-radius: 4px;
    background: #fff;
    background-clip: padding-box;

    &:focus {
      outline: 0;
      box-shadow: 0 0 0 3px rgb(131 192 253/50%);
    }

    @media (min-width: 1024px) {
      width: 73px;
      height: 60px;
    }
  }

  .code-button {
    margin-top: 40px;
    max-width: 250px;

    @media (min-width: 1024px) {
      margin-top: 80px;
      max-width: 425px;
    }
  }
`;
const CheckinError = styled_components_1.default.div `
  color: #ff0000;
  font-style: italic;
  margin-top: 20px;
`;
const ConventionModal = ({ checkinError, disableButton, AuthInputRef, checkinConvention, onChangeInput, onClose, }) => {
    const [isCodeInvalid, setIsCodeInvalid] = (0, react_1.useState)(true);
    const [code, setCode] = (0, react_1.useState)("");
    const checkCode = (e) => {
        const isValidCode = !Number.isNaN(Number(e)) && e.length === 6;
        setIsCodeInvalid(!isValidCode);
        setCode(e);
    };
    return (react_1.default.createElement(ConventionModalWrapper, null,
        react_1.default.createElement(IconButton_1.default, { "aria-label": "close", className: "collapse-btn", onClick: () => {
                onClose();
            }, sx: {
                position: "absolute",
                right: 8,
                top: 8,
                zIndex: "2",
                backgroundColor: "#fff",
                opacity: "0.75",
            } },
            react_1.default.createElement(Close_1.default, null)),
        react_1.default.createElement(material_1.Typography, { className: "modal-title" },
            " ",
            i18n_js_1.default.t("convention_code_text"),
            " "),
        react_1.default.createElement(react_auth_code_input_1.default, { ariaLabel: i18n_js_1.default.t("convention_code"), onChange: (e) => {
                onChangeInput(e);
                checkCode(e);
            }, inputClassName: "code-input", 
            // id="aqa_convention_code" //CHECK
            ref: AuthInputRef }),
        checkinError && react_1.default.createElement(CheckinError, null, checkinError),
        react_1.default.createElement(material_1.Button, { variant: "contained", fullWidth: true, size: "large", disabled: isCodeInvalid || disableButton, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                yield checkinConvention(code);
                onClose();
            }), className: "code-button", id: "aqa_log_into_convention" }, i18n_js_1.default.t("log_in_convention"))));
};
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue("currentLocale"),
    userData: store.getValue("userData"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(ConventionModal));
